module.exports = __webpack_public_path__ + "media/application/images/icons/worth-considering-3d5e1e2c3e7d891fd49ecf807ba40649.svg";